var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivingroom3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.74 155.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.67,126.86c-17.13,.34-45.1,.86-68.49,1.95C44.77,129.91,1.38,133.83,.03,141.11c-1.36,7.28,47.75,12.35,68.14,12.41,20.39,.06,77.55,2.65,108.3,1.28,30.75-1.37,98.64-4.6,99.26-13.69,.62-9.09-42.25-10.77-61.64-11.88-19.39-1.11-67.61-2.57-77.43-2.37Z",
    style: {
      fill: "#8aabb2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.38,153.62c-18.29,0-39.84-.58-57.15-1.05-12.04-.33-22.44-.61-29.05-.63-17.48-.05-55.68-3.84-64.11-9.1-1.37-.85-1.27-1.38-1.24-1.56,.92-4.94,34.06-9.42,65.57-10.89,22.15-1.03,48.34-1.55,65.68-1.89l2.68-.05c.57-.01,1.28-.02,2.11-.02,12.86,0,56.04,1.3,74.93,2.38l4.29,.24c16.55,.91,55.29,3.03,54.82,10.01-.25,3.6-17.22,8.64-96.66,12.17-5.87,.26-13.22,.39-21.87,.39Z",
    style: {
      fill: "#b5cdd2"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25,118.3c.31-.02,1.04-.18,1.63-.82,.6-.65,.77-1.53,.82-2.07-.02-28.57-.05-57.15-.07-85.72h2.24c-.03,28.55-.06,57.11-.1,85.66,0,.13,0,.32,.04,.53,0,.04,.15,.94,.76,1.6,.6,.64,1.34,.8,1.63,.82,4.81,.24,8.31,.95,8.31,1.8,0,1.04-5.28,1.89-11.8,1.89s-11.8-.84-11.8-1.89c0-.85,3.51-1.57,8.33-1.8Z",
    style: {
      fill: "#7c4847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.84,0H11.6L.69,29.69H44.75L33.84,0Z",
    style: {
      fill: "#ff896a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.92,0h-8.39c-3.08,9.9-6.15,19.79-9.23,29.69h26.85c-3.08-9.9-6.15-19.79-9.23-29.69Z",
    style: {
      fill: "#e57761"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.99,23.28l-.31-.35c3.82-4.34,8.46-7.86,13.44-10.2l.17,.46c-4.93,2.31-9.53,5.8-13.3,10.09Z",
    style: {
      fill: "#ff9c88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.23,22.84l-.19-.45c2.84-1.61,6.01-2.59,9.17-2.82l.03,.5c-3.1,.23-6.22,1.19-9,2.77Z",
    style: {
      fill: "#ff9c88"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.33,
    y: 131.85,
    width: 16.04,
    height: 3.99,
    style: {
      fill: "#663b3b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.09,
    y: 131.83,
    width: 16.04,
    height: 3.99,
    style: {
      fill: "#663b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,72.5c-4.6-9.27-16.76-13.55-26.98-8.5,1.83-2.38,6.12-8.65,4.92-15.83-1.75-10.47-14.59-19.53-31.23-18.44H71.62c-12.1-.54-22.64,6.4-25.82,16.31-3.17,9.89,2.28,18.66,3.15,20.01-11.09-7.73-25.77-3.41-30.6,6.45-4.54,9.26,0,22.52,11.62,27.47v26.18c-.28,1.86,.42,3.7,1.84,4.79,1.65,1.27,3.54,.98,3.87,.92H230.84c.33,.06,2.23,.34,3.87-.92,1.42-1.09,2.12-2.94,1.84-4.79v-26.18c11.52-4.25,16.55-17.51,11.62-27.47Z",
    style: {
      fill: "#3f6177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.18,64.22c1.83-2.38,6.12-8.65,4.92-15.83-1.75-10.47-14.59-19.53-31.23-18.44H71.6c-12.1-.54-22.64,6.4-25.82,16.31-3.17,9.89,2.28,18.66,3.15,20.01,1.57,3.43,3.23,7.82,4.42,13.08,1.27,5.63,1.64,10.62,1.65,14.57,20.3-1.34,41.42-2.26,63.29-2.67,33.67-.62,65.66,.06,95.8,1.65,.45-4.79,1.32-10.37,2.95-16.47,1.23-4.58,2.67-8.66,4.14-12.22Z",
    style: {
      fill: "#3a596b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.28,93.85l-.98,14.86c26.03-.85,52.67-1.39,79.88-1.59,27.02-.19,53.48-.04,79.35,.43,.05-4.83,.11-9.65,.16-14.48-23.54-1.81-48.89-2.9-75.85-2.87-29.51,.04-57.12,1.43-82.55,3.64Z",
    style: {
      fill: "#34505e"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M221.83,63.7c-.21,.1-.42,.2-.64,.3-2.34,5.92-4.53,12.8-6.1,20.56-.57,2.8-1.01,5.5-1.36,8.1-30.24-1.78-62.47-2.59-96.48-1.99-21.45,.38-42.14,1.3-62,2.63-.1-2.35-.32-4.84-.7-7.47-1.13-7.85-3.33-14.51-5.62-19.79l-.73-.48c2.16,5.04,4.52,11.93,5.8,20.34,1.39,9.19,1.01,17.08,.29,22.81,26.1-.49,52.46-.83,79.08-1.03,26.98-.2,53.7-.24,80.15-.13-.09-4.11,.07-9,.73-14.45h0l.1-.42h-.06c.34-2.57,.77-5.25,1.32-8.01,1.58-7.92,3.81-14.94,6.2-20.99Zm-8.93,43.32c-26.24-.12-52.75-.08-79.53,.11-26.46,.19-52.66,.53-78.6,1.02,.47-3.94,.76-8.79,.51-14.3,21.9-1.46,44.86-2.43,68.78-2.74,31.54-.41,61.47,.36,89.62,1.97-.65,5.22-.83,9.93-.79,13.94Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9,91.62c-1.6-2.59-2.26-5.68-1.87-8.69,.46-3.57,2.48-6.65,5.26-8.04l-.22-.45c-2.93,1.46-5.05,4.69-5.54,8.43-.4,3.13,.28,6.33,1.94,9.02,1.66,2.69,4.21,4.74,7.18,5.79l.17-.47c-2.87-1.01-5.33-2.99-6.92-5.58Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.43,94.04c-.52-.55-1.04-1.15-1.38-1.86-.33-.68-.42-1.38-.28-2h.09l.07-.14c.05-.1,.05-.22-.02-.32l-.13-.15-.15,.02c-.08,0-.24,.06-.31,.29-.24,.76-.14,1.66,.27,2.52,.37,.77,.92,1.41,1.47,1.99,.42,.44,.91,.93,1.54,1.21l.2-.46c-.55-.24-1-.69-1.38-1.1Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,43.32l-.12-.49c-14.32,3.44-27.85,11.17-38.08,21.76l.36,.35c10.16-10.53,23.6-18.21,37.83-21.62Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.37,58.72l-.21-.46c-4.2,1.9-7.71,5.39-9.64,9.57-.29,.63-.25,1.13,.1,1.4l.3-.4c-.21-.16-.01-.65,.05-.79,1.88-4.08,5.3-7.48,9.39-9.33Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.91,100.48l-.07-.5c-8.33,1.16-16.8,1.56-25.21,1.19l-.02,.5c2.01,.09,4.03,.13,6.05,.13,6.43,0,12.88-.44,19.25-1.33Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,97.43l-.24-.44c-.93,.51-1.94,.85-2.99,1l.07,.5c1.11-.16,2.18-.52,3.16-1.06Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.36,94.79l-.35-.36c-.45,.44-.99,.8-1.57,1.04l.19,.46c.64-.27,1.23-.66,1.73-1.15Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.37,
    y: 101.88,
    width: 0.92,
    height: 0.5,
    style: {
      fill: "#2f4954"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.05,80.31c-.52,.62-1.1,1.27-1.75,1.93-.76,.78-1.51,1.46-2.23,2.06,.87-.13,1.8-.31,2.79-.56,1.49-.37,2.81-.83,3.95-1.3-.35-.14-.77-.35-1.21-.65-.74-.5-1.24-1.07-1.56-1.5Z",
    style: {
      fill: "#fdb580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.68,81.35c.54,.47,1.19,.8,1.85,1.09,4.61,2,9.91,1.78,14.65,3.45,.26,.09,.54,.21,.67,.45,.12,.22,.08,.49,.05,.74-.22,1.6-.16,3.23,.15,4.81-1.62-.25-3.31,.07-4.74,.87-1.49,.84-2.86,2.26-4.57,2.16-1.23-.07-2.27-.94-3.02-1.91-.76-.97-1.33-2.08-2.18-2.97-2.02-2.13-5.5-2.92-6.61-5.64-.45-1.08-1.04-4.07,.02-4.96,1.35-1.14,2.89,1.19,3.74,1.92Z",
    style: {
      fill: "#fdb580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.58,90.55c.82-5.17-4.95-9.04-8.09-14.07-.46-.74-.94-1.48-1.62-2.02-.84-.67-1.91-.96-2.87-1.44-2.02-1.02-3.46-2.88-4.84-4.67-3.5-4.57-7-9.14-10.51-13.71-1.24-1.62-2.5-3.26-4.13-4.48-1.63-1.23-3.7-2-5.71-1.65-3.6,.63-5.61,4.38-7.41,7.56-3.44,6.07-7.94,11.45-11.96,17.15-.39,.56-1.57,1.88-1.59,3.71-.02,1.69,.92,3,1.21,3.4,.97,1.32,2.2,1.91,2.77,2.14-1.51,.54-3.39,1.13-5.59,1.62-1.1,.24-3.21,.66-5.9,.89-4.98,.42-9.29-.04-12.02-.34-4.55-.51-7.74-1.25-8.81,.34-.23,.34-.3,.69-.32,.92-.16,.87-.29,2-.21,3.33,.06,1.01,.23,1.89,.42,2.61,.11,.49,.36,1.2,.93,1.83,1.52,1.67,4.14,1.33,8.03,1.19,3.55-.12,1,.01,8.14,.09,3.52,.04,7.05,.07,10.53-.41,2.39-.33,4.75-.92,7.16-1.03,2.64-.13,5.26,.31,7.86,.8,6.56,1.23,17.45,3.24,22.64,3.48,5.14,.24,12.46-.69,21.62-6.11,.17-.48,.25-.88,.28-1.11Zm-42.37-8.58c-2.24-.13-4.49-.26-6.72-.39,1.75-2.16,3.17-3.97,4.18-5.27,4.04-5.21,5.21-7.03,5.76-7.94,.96-1.58,1.86-3.2,2.68-4.85,1.21,1.82,2.28,3.74,3.2,5.74,1.19,2.59,1.38,3.95,2.27,6.16,.78,1.92,2.09,4.58,4.42,7.54-5.24-.35-10.5-.68-15.79-.99Z",
    style: {
      fill: "#9b5c5c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.14,61.19l-.19,.23c.33,.23,.76,.59,1.17,1.11,.4,.51,.65,1,.8,1.37l.18-.37c-.12-.33-.33-.79-.72-1.27-.44-.55-.93-.88-1.25-1.07Z",
    style: {
      fill: "#895252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,85.41l-.37-.41c-1.42,1.28-2.67,2.75-3.72,4.35l.46,.3c1.02-1.56,2.24-2.99,3.63-4.24Z",
    style: {
      fill: "#895252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,90l.51,.21c.57-1.4,1.29-2.74,2.15-3.98l-.45-.32c-.88,1.27-1.63,2.65-2.2,4.09Z",
    style: {
      fill: "#895252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,82.07c.26,.13,.51,.25,.77,.38,.69-.12,1.39-.24,2.1-.36,1.21-.19,2.4-.36,3.56-.51l.43-.54c-1.29,.11-2.65,.27-4.09,.5-.97,.16-1.9,.33-2.79,.53Z",
    style: {
      fill: "#895252"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.61,79.41c-1.17,1.09-2.49,1.98-3.94,2.65-.24,.11-.49,.22-.76,.3-.24,.07-.43,.08-.55,.1-.3,.03-.55,.04-.75,.03,.12,.16,.25,.32,.37,.48,.03,0,.07,0,.12,0,.14,0,.51,0,.94-.13,.3-.09,.59-.21,.84-.33,1.49-.69,2.86-1.61,4.06-2.73l-.34-.37Z",
    style: {
      fill: "#895252"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "166.43 68.86 168.09 74.94 183.85 77.71 181.36 70.82 166.43 68.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.54 71.31 166.43 68.86 168.09 74.94 166.96 76.51 164.54 71.31",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.9,70.82h1.02l-.38,.49,2.42,5.2-.3,.28c-.92-1.99-1.84-3.98-2.77-5.96Z",
    style: {
      fill: "#ffd05b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.54 71.31 184.17 73.75 183.85 78.61 168.09 74.94 172.54 71.31",
    style: {
      fill: "#fdb752"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.66 76.78 168.09 74.94 183.85 78.6 183.21 80.78 166.66 76.78",
    style: {
      fill: "#e5a34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.39,53.95c-2.54,2.33-4.84,3.97-6.54,5.07-2.37,1.53-3.41,1.86-4.59,1.81-1.59-.06-3-1.04-4.15-2.14-.19-.18-.37-.37-.44-.62-.13-.51,.33-.97,.73-1.31,1.69-1.4,3.38-2.8,5.07-4.19-.26-.14-.51-.29-.77-.43-1.55,1.31-3.1,2.61-4.65,3.92-1.97,1.66-3.95,3.33-5.55,5.35-.75,.94-1.41,1.95-1.97,3.01-1.03,1.94-1.72,4.04-2.83,5.93-1.1,1.89-2.74,3.63-4.86,4.16,1.43,2.58,2.79,5.2,4.11,7.84,1.23-.33,3.03-.96,4.91-2.22,2.24-1.5,2.82-2.71,6.67-7.41,2.43-2.97,4.05-4.73,5.79-6.67,1.85-2.05,2.82-3.06,4.18-4.19,.66-.55,2.43-1.99,4.99-3.47,.88-.51,1.65-.91,2.22-1.19-.78-1.08-1.56-2.16-2.34-3.25Z",
    style: {
      fill: "#cad6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,52.85c-.23,.19-.91,.75-1.4,1.68-.13,.26-.28,.66-.57,1.46-.47,1.3-.46,1.45-.68,1.74-.39,.51-1,.79-1.57,1.08-.92,.47-2.96,1.93-3.98,3.49-1.16,1.79-.54,2.74-2.17,5.53-.28,.48-.53,.85-.71,1.1-.97-.6-1.94-1.2-2.9-1.79-.08,.3-.15,.75-.05,1.26,.09,.49,.28,.73,.46,1.21,.14,.37,.29,.93,.3,1.68-1.17,.76-2.33,1.53-3.5,2.29,.85,.61,1.69,1.23,2.54,1.84,.77-.45,1.86-1.19,2.96-2.31,.28-.29,1.43-1.49,2.69-3.81,.99-1.82,1.29-2.95,1.73-4.03,1.16-2.86,3.19-4.78,7.25-8.61,1.27-1.2,3.03-2.78,5.26-4.51-.24-.12-.64-.3-1.15-.41-2.4-.53-4.35,.98-4.5,1.1Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.14,67.85c-8.29,9.42-9.9,11.43-11.4,12.38-.46,.29-.87,.46-.87,.46-3.25,1.61-4.7,1.02-7.38,2.33-1.22,.6-2.04,1-2.62,1.94-.82,1.3-.39,2.35-.87,4.28-.23,.92-.71,2.23-1.85,3.7-.35,.27-1.41,1.15-1.62,2.62-.05,.36-.22,1.48,.41,2.07,.75,.7,2.21,.24,2.87,.03,7.8-2.44,6.71-1.39,9.82-2.87,2.99-1.43,5.19-2.98,8.35-5.21,1.03-.73,1.87-1.35,2.44-1.78,2.01,.63,3.73,1.11,5.05,1.46,2.44,.65,3.24,.79,4.16,.55,1.29-.35,2.28-1.36,3.16-2.36,5.42-6.16,9.55-14.06,8.91-22.24-.18-2.32-.85-3.78-1.2-4.48-1.11-2.23-2.72-3.6-3.69-4.31-2.57,1.49-6.27,3.91-10.11,7.64-.33,.32-1.77,1.77-3.56,3.81Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M185.84,70.04c-.34,.41-.67,.76-.98,1.04v.23c.36-.33,.75-.7,1.14-1.12,.4-.43,.75-.84,1.06-1.24l-.37-.12c-.22,.37-.5,.78-.85,1.21Z",
    style: {
      fill: "#6aa077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.49,61.56c-1.56,1.68-2.63,3.19-3.31,4.25-.9,1.4-1.92,3.25-5.44,12.45-.37,.97-.68,1.77-.88,2.3-.34,.01-.8,.02-1.35-.01-.21-.01-.81,0-1.7-.22-1.65-.41-2.49-.63-3.61-.98-.2-.06-.48-.15-.86-.28-1.39-.47-1.75-.67-2.14-.77-.61-.15-1.54-.12-2.91,.75l.24,.5c1.18-.79,2.02-.85,2.57-.73,.37,.08,.6,.22,2.19,.78,.13,.05,.45,.16,.77,.27,.1,.03,1.72,.58,3.66,1.01,.18,.04,.93,.2,1.78,.23,.07,0,.13,0,.14,0,.63,0,1.12-.05,1.45-.1,.23-.5,.64-1.37,1.11-2.47,2.83-6.47,3.17-8.89,5.35-12.44,.59-.96,1.59-2.45,3.12-4.12l-.19-.4Z",
    style: {
      fill: "#6aa077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,84.46c-.51-.91-.2-1.98-.03-2.43l-.54-.12c-.14,.52-.39,1.71,.24,2.72,.36,.58,.86,.86,1.2,1.05,2.05,1.11,4.76,1.99,5.91,2.34,.09-.08,.19-.16,.28-.24-.89-.29-3.82-1.27-5.91-2.33-.3-.15-.82-.42-1.14-1Z",
    style: {
      fill: "#6aa077"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.02,45.27c.48-1.1,1.02-2.72,1.12-4.72,.08-1.51,.18-3.99-1.38-6.36-.85-1.29-2.05-2.37-3.48-2.93-.95-.37-1.97-.51-2.98-.57-1.33-.09-2.69-.04-3.96,.38-2.02,.67-3.69,2.33-4.37,4.34-.66,1.96-.42,4.1-.16,6.16,.03,.24,.06,.49,.17,.71,.17,.35,.4,.56,.45,.6,.29,.27,.52,1.17,.29,3.82-.01,.16,.03,.28,.06,.35,.18,.36,.71,.55,1.33,.45,.92,2.52,2.51,4.12,3.94,3.99,.27-.02,.6-.11,.97-.37,.15,.47,.3,.95,.45,1.42-1.13,.82-3.61,2.67-5.38,4.47-.15,.15-.42,.43-.45,.84-.11,1.3,2.25,2.81,4.43,3.09,.94,.12,1.72,0,2.2-.12,1.83-1.05,3.85-2.38,5.92-4.06,1.18-.95,2.24-1.9,3.19-2.83-.45-.77-.91-1.7-1.3-2.77-.84-2.31-1.05-4.39-1.07-5.91Z",
    style: {
      fill: "#fdb580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.76,57.86v-1.38h-8.65v1.38c-.02,.23-.2,2.41,1.38,3.7,.61,.5,1.27,.68,1.69,.76h2.5c.42-.08,1.08-.26,1.69-.76,1.59-1.29,1.41-3.47,1.38-3.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.37,63.99c-.02,.28,.16,.56,.47,.71-.05,.06-.2,.28-.19,.57,.02,.47,.42,.72,.46,.74-.07,.04-.16,.1-.21,.2-.16,.3,.12,.72,.27,.94,.08,.12,.22,.37,.6,.63,.51,.36,1.1,.74,1.86,1.01,.19,.07,.35,.12,.45,.15,.14-.17,.29-.34,.42-.53,1.04-1.41,1.51-2.91,1.72-4.14-.02-.07-.04-.18-.07-.3-.09-.35-.2-.59-.23-.67-.46-1-.92-1.99-1.38-2.99-.07-.15-.25-.36-.47-.38-.29-.02-.52,.33-.57,.4-.32,.49-.14,1.08-.1,1.22-.2,.16-.48,.35-.84,.51-.32,.14-.62,.21-.85,.25h-1.73c-.02,.11-.06,.33,.02,.58,.13,.44,.5,.64,.58,.69-.05,.06-.17,.2-.19,.41Z",
    style: {
      fill: "#fdb580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,80.96c-.5,.91-1.22,1.36-1.52,1.52-2.8-1.6-4.74-1.89-6.04-1.82,0,0-1.16,.06-2.65-.19-1.13-.19-1.84-.46-2.4-1.02-.26-.26-.43-.52-.53-.71-.19-.08-.57-.28-.88-.69-.2-.27-.3-.53-.35-.71l-.6-.24c-.18-.09-.86-.46-1.04-1.18-.03-.14-.04-.27-.04-.4-.35-.08-2-.44-2.49-.86-.06-.05-.17-.16-.18-.3,0-.22,.24-.35,.45-.4,.79-.2,1.61-.14,2.42-.08,1.74,.12,3.48,.21,5.22,.26,.14,0,.28,0,.41-.06,.12-.06,.22-.21,.17-.34-.03-.08-.11-.14-.19-.19-.52-.3-1.18-.25-1.72-.52-.09-.05-.19-.11-.22-.22-.02-.07,0-.14,.03-.2,.16-.33,.59-.42,.95-.46,1.39-.16,2.9-.26,4.1,.45,.77,.46,1.32,1.2,1.92,1.87,.79,.9,1.71,1.7,2.73,2.5,.64,.5,1.59,1.17,2.87,1.83,.03,.34,.05,1.21-.46,2.14Z",
    style: {
      fill: "#fdb580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,44.62c-.17,.12-.35,.24-.43,.43-.05,.13-.05,.28-.05,.42,.1,2.51,.49,5.06,1.65,7.29,.61,1.17,1.41,2.22,2.22,3.27,1.06,1.39,2.13,2.79,3.39,4,.38,.37,.79,.73,1.12,1.14,.4,.5,.69,1.08,.85,1.7,.51-.42,.8-1.05,.93-1.69,.13-.64,.11-1.3,.08-1.96-.04-1.05-.1-2.12-.43-3.11-.55-1.64-1.82-2.95-3.19-4-.71-.55-1.55-1.2-1.51-2.1,.01-.27,.11-.52,.2-.77,.57-1.61,.95-3.36,.54-5.02-.35-1.44-1.45-2.86-2.95-3.2-.55-.12-.5-.07-.58,.44-.06,.41-.14,.81-.3,1.2-.32,.78-.85,1.48-1.53,1.97Z",
    style: {
      fill: "#d19347"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.07,42.21c-.13-.82-.89-1.48-1.71-1.5-.18,0-.38,.02-.53,.13-.18,.12-.27,.33-.39,.5-.41,.58-1.16,.84-1.88,.82-.71-.02-1.39-.29-2.04-.57-1.92-.84-3.77-1.85-5.5-3.04-.36-.25-.73-.5-1.14-.63-.42-.13-.91-.1-1.25,.17-.12,.1-.22,.23-.37,.27-.21,.06-.44-.09-.54-.29s-.09-.43-.07-.65c.22-2.13,1.48-3.32,1.48-3.32,1.37-1.65,2.78-3.35,5.43-4.32,.91-.33,4.94-1.82,8.34,.35,1.78,1.13,2.59,2.76,2.97,3.53,1.25,2.51,.99,4.82,.91,6.12-.12,2.07-.88,4.17-2.42,5.56-.26,.24-.58,.46-.93,.42-.14-.02-.27-.07-.39-.13-.31-.16-.6-.36-.86-.59-.69-.62-.18-.8,.28-1.2,.46-.39,.71-1.04,.61-1.63Z",
    style: {
      fill: "#e5a34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,43.62c0,.22-.18,.39-.39,.39s-.39-.18-.39-.39,.18-.39,.39-.39,.39,.18,.39,.39Z",
    style: {
      fill: "#7c4847"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.89,
    cy: 43.77,
    r: 0.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,42.1c.06-.4,.28-.8,.65-1.05,.36-.27,.81-.37,1.25-.37,.87,.04,1.66,.5,2.05,1.22-.79-.19-1.43-.38-2.07-.39-.64-.02-1.2,.12-1.87,.6Z",
    style: {
      fill: "#d19347"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.75,43.38c-.07,0-.13-.02-.16-.05l.14-.24s.13-.03,.22-.13c.08-.08,.16-.18,.19-.28,.02-.07,0-.16-.06-.18-.02,0-.06-.01-.09-.02-.09-.01-.23-.03-.3-.17-.04-.09-.02-.18,0-.24,.1-.31,.37-.55,.68-.6,.34-.06,.67,.1,.83,.38,.15,.26,.13,.57,.09,.77-.04,.26-.12,.52-.22,.76l-.25-.11c.1-.22,.16-.45,.2-.69,.04-.26,.02-.45-.06-.59-.1-.18-.33-.28-.54-.24-.21,.04-.39,.2-.46,.41-.01,.03,0,.04,0,.05,0,0,.05,0,.08,0,.05,0,.11,.01,.16,.04,.2,.08,.27,.32,.22,.51-.04,.17-.16,.29-.25,.39-.16,.17-.3,.23-.4,.23Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09,51.34l-.06-.2c.64-.5,1.35-1.12,2.06-1.88,.66-.69,1.19-1.37,1.63-1.98l.22,.09c-.43,.64-.99,1.37-1.71,2.11-.75,.78-1.5,1.39-2.14,1.86Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.17,47.68l-.04-.17c.19-.05,.38-.1,.57-.15,.16-.04,.27-.15,.3-.29,.02-.11-.02-.2-.04-.24l.18-.17c.13,.13,.16,.34,.09,.51-.11,.26-.42,.34-.58,.38l-.47,.13Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.32,49.81l-.17-.25c.3-.1,.74-.28,1.19-.62,.43-.32,.72-.67,.9-.92l.2,.14c-.2,.27-.51,.63-.95,.98-.44,.34-.86,.54-1.17,.67Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.79,62.99c.14,.18,.34,.43,.6,.72l.13-.12c-.23-.26-.41-.5-.53-.67-.19-.26-.29-.41-.39-.62-.14-.29-.19-.56-.22-.74l-.1,.07c-.01,.2,0,.52,.16,.85,.04,.09,.1,.19,.35,.5Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,67.18s.05-.02,.08-.03c.06-.03,.23-.13,.28-.31,.08-.27-.17-.64-.63-.93,.03-.01,.06-.02,.09-.04,.06-.03,.23-.13,.28-.31,.08-.29-.2-.68-.71-.98,.12-.04,.24-.1,.28-.2,.04-.1,.02-.24-.16-.49-.3-.43-.71-.65-1.13-.91-.41-.26-.85-.47-1.31-.62l-.08,.24c.46,.2,.93,.42,1.49,.67,0,0,.52,.24,.86,.69,.07,.09,.13,.2,.09,.29-.03,.07-.11,.1-.18,.12-.52,.14-1.09-.06-1.09-.06-.64-.23-1.22-.48-1.73-.71l-.12,.17c.67,.34,1.24,.57,1.69,.73,.2,.07,.6,.21,1.1,.15,.02,0,.06,0,.08-.01h0c.15,.08,.57,.33,.67,.71,.02,.07,.05,.2-.01,.29-.07,.11-.23,.12-.3,.12-.47,.03-2.57-.93-2.84-1.05l-.08,.11c.53,.29,.98,.51,1.3,.65,.88,.4,1.32,.51,1.6,.49,.18,.11,.5,.33,.59,.66,.02,.07,.05,.2-.01,.29-.07,.11-.23,.12-.3,.12-.47,.03-2.57-.9-2.84-1.01l-.12,.08c.53,.27,.98,.48,1.34,.64,.87,.39,1.32,.52,1.62,.49,.19,.12,.44,.33,.52,.61,.02,.07,.05,.2-.01,.29-.07,.11-.23,.12-.3,.12-.47,.03-2.28-.77-2.5-.86l.11,.17c.26,.11,.59,.25,.96,.41,1.05,.44,1.39,.56,1.69,.41,.04-.02,.23-.12,.28-.31,.07-.26-.16-.61-.58-.89Z",
    style: {
      fill: "#db9c72"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,75.87c-.74-.03-1.44-.09-2.09-.17v-.18c.66,.08,1.38,.14,2.15,.16,.86,.03,1.67,.02,2.41-.03l-.12,.22c-.73,.03-1.52,.03-2.35-.01Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,77.68c-.74-.03-1.44-.09-2.1-.17l-.06-.17c.65,.09,1.37,.15,2.14,.17,.48,.01,.93,0,1.36-.02l-.09,.22c-.4,0-.82,0-1.25-.03Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,79.05c-.72-.03-1.41-.08-2.08-.15l-.1-.17c.67,.08,1.39,.13,2.16,.15,.3,0,.59,0,.87,0-.02,.07-.05,.13-.07,.2-.26,0-.52-.01-.78-.02Z",
    style: {
      fill: "#db9c72"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M223.02,112.07c3.16,0,6.31,0,9.47,0v1.31c-3.16,0-6.32-.01-9.48-.02,0-.43,0-.86,.01-1.3Z",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.61,113.6c.66,.05,1.32,.11,1.98,.16-.19,8.82-.37,17.63-.56,26.45h-.99c-.15-8.87-.29-17.74-.44-26.61Z",
    style: {
      fill: "#a87a5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,113.59c-.65,.05-1.31,.11-1.96,.16,.19,8.82,.38,17.64,.57,26.46h.99l.4-26.62Z",
    style: {
      fill: "#a87a5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.23,112.87c-.56,.06-1.11,.11-1.67,.17,1.25,10.29,2.49,20.58,3.74,30.88h.81c-.96-10.35-1.92-20.7-2.88-31.04Z",
    style: {
      fill: "#a87a5b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,113.13l1.69,.24c-1.24,10.18-2.48,20.36-3.72,30.54h-.81c.95-10.26,1.9-20.52,2.84-30.79Z",
    style: {
      fill: "#a87a5b"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 238,
    cy: 111.69,
    rx: 19.08,
    ry: 2.38,
    style: {
      fill: "#ce936b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.77,104.5c-.42-1.26-1.26-2.13-1.94-2.67-.1-.51-.18-1.14-.15-1.86,.04-1.32,.38-2.38,.68-3.07h-5.29c.29,.69,.64,1.75,.68,3.07,.02,.72-.05,1.35-.16,1.86-.68,.54-1.52,1.41-1.94,2.67-.84,2.55,.36,5.67,3.05,7.84h2.02c2.69-2.17,3.9-5.3,3.05-7.84Z",
    style: {
      fill: "#e57761"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48,96.89h-5.56c-.17,0-.31-.14-.31-.31h0c0-.17,.14-.31,.31-.31h5.56c.17,0,.31,.14,.31,.31h0c0,.17-.14,.31-.31,.31Z",
    style: {
      fill: "#ff896a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.46,71.91c.2-.47,.32-.99,.33-1.5,0-.27-.02-.57-.2-.78-.27-.31-.81-.27-1.12,0-.31,.27-.43,.71-.45,1.12-.04,.92,.72,2.82,1.43,1.16Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,73.63c-.23,0-.44,.13-.62,.27-.32,.26-.6,.57-.81,.92-.28,.46-.51,1-.75,1.47,.29-.2,.61-.34,.95-.44,.4-.12,.81-.21,1.17-.4,.36-.2,.68-.53,.74-.95,.05-.41-.26-.87-.67-.87Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82,79.74c-.3-.07-.59,.14-.79,.36-.31,.33-.55,.72-.7,1.14l-.18,.14c.02,.12,.17,.17,.29,.18,.53,.06,1.08-.05,1.56-.31,.18-.1,.36-.23,.41-.43,.03-.13,0-.28-.04-.41-.09-.29-.25-.6-.55-.67Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.31,78.11c.4-.22,.48-1.69,.49-2.09,0-.26,0-.54-.11-.78s-.33-.45-.59-.47c-.37-.03-.69,.32-.76,.69-.07,.37,.04,.74,.16,1.1,.12,.4,.32,1.82,.82,1.55Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06,76.3c-.02-.49-.09-1.02-.43-1.39-.33-.36-1.01-.44-1.28-.03-.22,.33-.08,.78,.11,1.13,.2,.39,.64,1.27,1.12,1.38,.68,.16,.51-.58,.49-1.1Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.86,78.41c-.24-.09-.51-.11-.73,0-.33,.16-.47,.57-.41,.93s.29,.67,.54,.93c.36,.38,2.25,2.03,2.83,1.71,.65-.36-.59-1.83-.81-2.17-.37-.57-.78-1.17-1.41-1.41Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79,86.64c.42,.45,.77,.96,1.3,1.28,.25,.15,.52,.24,.79,.32,.34,.1,.75,.16,1.02-.06,.21-.17,.29-.46,.24-.72-.04-.26-.19-.5-.37-.7-.68-.77-2.11-1.31-3.14-1.08-.89,.2-.29,.5,.15,.97Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.37,82.52c-.3-.06-.61,.12-.78,.37-.17,.25-.23,.56-.26,.86-.06,.6,.14,4.02,1.19,2.49,.3-.44,.61-.9,.7-1.42,.08-.46,0-.94-.14-1.4-.11-.39-.32-.82-.71-.91Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,73.13c-.44-.09-.85,.34-.91,.78-.06,.45,.13,.88,.35,1.28,.25,.45,.53,.89,.93,1.2,.13,.1,.28,.2,.44,.19,1.03-.05,.12-2.03-.02-2.44-.14-.43-.35-.92-.8-1.01Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82,77.73c-.12,0-.24,.02-.34,.08-.26,.15-.3,.51-.31,.81-.02,.49-.04,.99,.15,1.44,.11,.27,.3,.51,.49,.73,.25,.3,1.17,1.55,1.64,1.1,.44-.42-.11-2.49-.3-2.97-.23-.58-.7-1.16-1.32-1.18Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.59,78.82c-.3-.07-.61-.03-.92,.03-.63,.13-1.74,.5-2.12,1.07-.48,.73,.62,1.23,1.28,1.27,.2,.01,.4-.02,.6-.05,.5-.08,1.02-.17,1.43-.46,.41-.3,.67-.87,.45-1.33-.13-.28-.42-.46-.72-.53Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.02,75.59c-.15-.25-.48-.35-.77-.31-.29,.05-.55,.21-.77,.4-.39,.33-1.11,1.04-1.15,1.59-.05,.77,.95,.55,1.51,.33,.68-.27,1.31-.88,1.29-1.61,0-.14-.03-.28-.11-.41Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,79.11c.1-.24,.08-.52,.02-.77-.09-.36-.29-.72-.64-.84-.3-.11-.64,0-.9,.2-.5,.38-1.49,1.78-.85,2.41,.56,.55,2.12-.39,2.37-.99Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,81.6c-.29-.19-.67-.13-.99,0-.53,.2-2.11,1.12-2.04,1.81,.09,.88,1.86,.86,2.43,.68,.27-.08,.52-.21,.71-.42,.31-.35,.37-.86,.29-1.33-.05-.29-.16-.59-.4-.75Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,92.76c-.53,.71,.16,2.35,1.09,2.35,.29,.03,.58-.07,.8-.26,.29-.25,.42-.67,.31-1.03-.21-.65-1.67-1.78-2.2-1.07Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.33,89.61c-.62-.18-3.6-.15-2.78,.99,.65,.9,2.63,1.2,3.41,.41,.13-.14,.24-.31,.26-.5,.04-.46-.45-.78-.89-.9Z",
    style: {
      fill: "#80c493"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,86.42s.07,0,.11-.01c.72-.25-.34-1.24-.53-1.59-.24-.45-.42-.95-.75-1.34-.16-.19-.35-.35-.57-.48-.22-.13-.47-.22-.71-.19s-.49,.22-.52,.47c-.02,.19,.07,.36,.15,.53,.28,.53,.56,1.07,.94,1.54,.38,.47,.87,.87,1.45,1.04,.08,.02,.16,.04,.25,.05-.7,.07-1.5,.45-1.8,.72-.33,.29-.6,.8-.34,1.16,.22,.3,.67,.29,1.03,.21,.57-.13,2.59-.84,2.21-1.66-.16-.34-.52-.45-.93-.44Z",
    style: {
      fill: "#80c493"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.37,82.83c.27-.61,.7-1.48,1.38-2.54,.23-.03,.47-.06,.7-.09,.34,.05,.85,.1,1.44,.01,.89-.13,1.62-.49,1.6-.55-.02-.05-.57,.14-1.48,.23-.61,.06-1.11,.05-1.45,.03l-.58,.05c.21-.32,.5-.7,.9-1.08,.62-.59,1.26-.94,1.72-1.13,.23-.14,.54-.36,.88-.67,.52-.49,.89-1.01,.85-1.04-.04-.03-.47,.47-1.3,1.05-.22,.16-.46,.3-.66,.42-.37,.23-.69,.41-.92,.53-.09-.2-.21-.51-.29-.89-.15-.7-.09-1.22-.12-1.22-.03,0-.12,.52-.06,1.15,.04,.48,.15,.86,.24,1.12-.75,.61-1.42,1.28-2.01,2.01h0c-.34,.47-.69,1.1-1.29,2.41-.15,.33-.31,.65-.47,.98-.11-.52-.19-1.04-.21-1.57-.02-.33-.08-.78-.24-1.29-.35-1.17-.99-1.99-1.05-1.95-.06,.03,.49,.88,.71,2.28,.06,.4,.08,.74,.09,.98,0,.32,.04,.68,.09,1.06,.05,.35,.13,.7,.22,1.05-.43,.83-1.15,2.02-2.34,3.18-1.22,1.2-2.46,1.91-3.32,2.32,.2-1.11,.59-2.19,1.17-3.16l.16-.26c.17-.23,.38-.57,.54-1,.18-.48,.24-.91,.26-1.22-.39-.82-.78-1.63-1.17-2.45,.2-.08,.48-.22,.76-.46,.34-.29,.57-.62,.55-.64-.02-.02-.26,.25-.68,.51-.28,.17-.54,.28-.71,.34-.22-.82-.42-1.78-.54-2.86-.08-.77-.11-1.49-.11-2.14,.37-.19,.9-.51,1.42-1.01,.53-.51,.86-1.02,.84-1.04-.03-.03-.51,.62-1.39,1.24-.35,.24-.65,.42-.87,.53,.1-1.17,.2-2.34,.3-3.51,.08-.38,.16-.92,.14-1.58-.02-.52-.1-1.03-.14-1.03-.04,0-.01,.53-.09,1.3-.05,.53-.13,.97-.19,1.25-.18,1.24-.35,2.49-.53,3.73-.18-.14-.42-.35-.69-.64-.62-.67-.88-1.25-.91-1.23-.03,.02,.27,.79,.89,1.58,.26,.32,.51,.57,.7,.73,0,.58,.04,1.2,.12,1.86,.29,2.36,1.06,4.27,1.79,5.66-.03,.25-.1,.57-.24,.93-.15,.39-.34,.68-.49,.9l-.16,.26c-1.08,1.82-1.57,3.98-1.35,6.09,.07,.67,.21,1.34,.34,1.99,.09,.42,.17,.86,.24,1.3-.6-1.3-1.36-2.52-2.29-3.62l-.21-.24c-.25-.3-.5-.58-.7-.89-.31-.47-.54-1.04-.73-1.75-.43-1.64-.44-3.37-.45-5.04,0-.07,0-.14,0-.22,.38-.12,.92-.33,1.54-.66,.6-.32,1.08-.66,1.06-.69-.02-.03-.64,.37-1.59,.69-.42,.14-.77,.22-1.01,.27-.02-1.15-.03-2.3-.05-3.44,.25-.12,.59-.33,.92-.67,.37-.39,.58-.83,.54-.85-.03-.02-.26,.35-.74,.7-.28,.21-.54,.33-.73,.41,0-.56-.02-1.11-.02-1.67,0-.32-.02-.79-.19-1.32-.14-.45-.35-.85-.4-.83-.05,.02,.15,.53,.24,1.31,.05,.41,.05,.75,.04,.97l-.06,3.89c-.38-.25-.94-.66-1.55-1.22-.76-.71-1.2-1.3-1.24-1.27-.04,.03,.43,.78,1.11,1.51,.62,.68,1.24,1.15,1.68,1.45l-.03,1.65c-.14,1.43-.05,3.21,.46,5.16,.1,.38,.22,.73,.35,1.05-.69-.13-1.6-.38-2.58-.87-1.42-.71-2.37-1.63-2.93-2.27,.11-.23,.25-.54,.35-.93,.35-1.26,.15-2.35,.09-2.35-.05,0,.04,.95-.35,2.26-.1,.33-.21,.6-.29,.79l-.19-.24c-.37-.15-.88-.38-1.44-.75-1.29-.86-1.91-1.83-1.95-1.8-.04,.03,.6,1.1,1.79,2.04,.26,.21,.49,.36,.67,.48-.24,.18-.61,.44-1.1,.69-.7,.36-1.2,.48-1.19,.52,.01,.05,.77-.04,1.53-.41,.44-.22,.77-.47,.98-.66l.31,.18c.45,.56,1.83,2.18,3.41,2.87,.25,.11,.88,.36,1.67,.6,.59,.18,1.1,.29,1.46,.37,.06,.12,.12,.25,.19,.36,.22,.34,.48,.65,.74,.94l.2,.24c.51,.58,1.07,1.34,1.59,2.27,.33,.6,.59,1.18,.79,1.7,.3,0,.6,0,.89,0-.07-.7-.21-1.4-.35-2.07-.13-.63-.27-1.29-.33-1.94-.07-.67-.06-1.35,.02-2.02,.95-.44,1.85-.99,2.67-1.63,.36,.74,1.11,1.99,2.53,2.97,.58,.4,1.15,.67,1.63,.85,.2,.15,.47,.38,.73,.72,.49,.62,.63,1.19,.67,1.17,.05-.02-.03-.72-.47-1.36-.28-.41-.61-.67-.86-.83l-.39-.37c.18-.03,.38-.08,.6-.15,.61-.21,1.06-.54,1.33-.8,.2-.13,.49-.3,.85-.43,1.02-.36,1.81-.17,1.81-.23,0-.08-1.13-.51-2.28-.09-.29,.11-.52,.24-.68,.36-.24,.21-.63,.5-1.17,.72-.42,.17-.8,.24-1.08,.27-.14-.07-.29-.15-.43-.24-1.08-.68-1.91-1.7-2.4-2.87,.82-.69,1.57-1.47,2.21-2.34,.46,.13,.93,.2,1.4,.2h.04c.35,.01,.86,.06,1.45,.23,.97,.28,1.53,.73,1.56,.67,.04-.06-.61-.71-1.56-1.09-.57-.23-1.09-.29-1.46-.31-.17,0-.36-.01-.57-.04-.19-.02-.38-.06-.56-.1,.3-.44,.59-.9,.84-1.38,.31-.59,.49-1.01,.63-1.32Z",
    style: {
      fill: "#7c4847"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.55,108.42c-2.9,.01-5.8,.03-8.7,.04l-10.05,3.62c3.23,0,6.46,0,9.69,0,3.02-1.22,6.04-2.44,9.06-3.66Z",
    style: {
      fill: "#5dafa1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.56,109.27c-3.1,.1-6.2,.2-9.3,.3-3.08,1.26-6.17,2.53-9.25,3.79l-.2,.14c3.23,0,6.46,.01,9.69,.02,3.02-1.42,6.05-2.83,9.07-4.25Z",
    style: {
      fill: "#4cb4d3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.16 108.58 241.16 109.35 232.49 113.38 232.49 112.07 241.16 108.58",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.8,112.07h.22v1.3l-.22,.14v-1.43Z",
    style: {
      fill: "#519c92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,108.34c-2.58,.08-5.16,.17-7.74,.25-2.57,1.05-5.13,2.11-7.7,3.16l-.17,.11c2.69,0,5.37,0,8.06,.01,2.52-1.18,5.03-2.36,7.55-3.54Z",
    style: {
      fill: "#ffd05b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,107.63l-7.24,.03c-2.79,1-5.58,2.01-8.37,3.01,2.69,0,5.37,0,8.06,0,2.51-1.01,5.03-2.03,7.54-3.04Z",
    style: {
      fill: "#ffd05b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,110.67c2.63,0,5.26,0,7.88,0v1.09c-2.63,0-5.26,0-7.89-.01,0-.36,0-.72,.01-1.08Z",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.97 107.76 238.97 108.41 231.76 111.77 231.76 110.67 238.97 107.76",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7,110.68h.18v1.08l-.18,.11v-1.19Z",
    style: {
      fill: "#e5a34c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,29.63c.19,.12,.48,.36,.52,.62,.06,.43-1.25,.61-1.45,.64-1.27,.19-2.27-.14-4.9-.77,0,0-.12-.03-.26-.06-.8-.18-1.79-.38-1.81-.33-.01,.06,1.38,.38,2.9,1.33,.47,.3,.71,.53,.8,.87,.15,.57-.34,1.14-.9,1.3-.56,.16-1.16,.03-1.73-.11-2.83-.67-5.69-1.22-8.48-2.02-1.4-.4-3.41-.92-5.92-1.37h-11.5c.52,.07,1.31,.16,2.29,.23,1.8,.12,2.57,.04,2.75,.44,.17,.38-.26,1.05-.77,1.43-1.15,.86-2.75,.33-4.77-.18-1.53-.39-3.73-.87-6.53-1.25,.75,1.78,1.72,2.7,2.52,3.22,.92,.6,1.9,.86,1.97,1.48,.05,.43-.5,.87-.87,1.06-1.74,.87-4.3-1.44-4.45-1.58-.64-.2-1.64-.49-2.87-.79-1.7-.42-2.33-.37-2.89-.88-.39-.35-.97-1.17-.77-3.17-1.33,.25-3.22,.58-5.51,.85-4.52,.54-6.28,.37-6.75,1.38-.78,1.66,3.17,4.01,2.44,5.75-.64,1.51-4.59,2.1-6.62,.38-2.03-1.73-2.02-5.66-.5-8.19,3.03-5.03,10.1-1.28,16.41-7.19,1.41-1.32,2.98-3.31,6.22-4.73,.8-.35,2.06-.69,4.62-1.28,7.27-1.69,9.89-1.63,11.06-1.56,.86,.05,1.56,.13,2.01,.19-.15-.42-.35-1.22-.2-2.19,.24-1.57,1.25-2.52,1.57-2.8-.11-.49-.23-1.15-.29-1.95-.11-1.29-.16-2.01,.16-2.22,.67-.45,2.67,1.47,3.08,1.87,1.37-.01,2.75-.02,4.12-.03,2.39-2.53,3.24-2.77,3.59-2.56,.17,.1,.25,.32,.35,1.9,.06,1.01,.1,1.87,.13,2.5,2.27,2.69,2.78,4.9,2.8,6.46,.01,1.06-.16,4.5,.02,7.16,.06,.85,.3,1.24,.47,1.54,1.37,2.36,5.68,3.2,7.95,4.65Z",
    style: {
      fill: "#c0a592"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.46,29.95c-.98-.07-1.77-.16-2.29-.23-2.08,.12-4.15,.25-6.23,.37-.27,.1-.53,.2-.8,.3-.68,.16-1.5,.29-2.43,.31-2.14,.04-3.86-.52-4.93-.98-.2,2,.39,2.82,.77,3.17,.56,.51,1.19,.47,2.89,.88,1.23,.3,2.23,.59,2.87,.79,.15,.14,2.71,2.45,4.45,1.58,.34-.17,.89-.59,.87-1.06-.02-.63-.9-1.01-1.68-1.54-.82-.55-1.87-1.48-2.81-3.15,2.53,.37,4.55,.8,5.97,1.14,2.56,.61,4.17,1.17,5.34,.28,.51-.38,.94-1.05,.77-1.43-.18-.4-.96-.32-2.75-.44Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,29.63c-1.6-1.02-3.96-1.86-4.65-2.15-.89-.36-2.08-1.05-3.3-2.5-.48,.27-1.15,.72-1.78,1.45-.39,.46-.67,.9-.86,1.27-.7-.64-1.4-1.27-2.09-1.91-1.14-.02-2.56,.07-4.16,.47-3.2,.79-5.46,2.4-6.7,3.46h2.32c2.51,.45,4.52,.97,5.92,1.37,2.79,.8,5.65,1.35,8.48,2.02,.57,.14,1.17,.27,1.73,.11,.56-.16,1.05-.74,.9-1.3-.09-.33-.33-.57-.8-.87-1.52-.95-2.92-1.28-2.9-1.33,.01-.05,1,.15,1.81,.33,.15,.03,.25,.06,.26,.06,2.63,.63,3.63,.95,4.9,.77,.2-.03,1.5-.2,1.45-.64-.03-.26-.34-.5-.52-.62Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.46,8.02l4.12-.03c-.09,2.05-.65,3.06-.99,3.53-.07,.09-.46,.63-.68,.55-.13-.05-.12-.3-.28-.95-.11-.44-.18-.75-.28-.75-.1,0-.19,.33-.3,.75-.16,.63-.15,.86-.29,.92-.25,.1-.69-.45-.74-.51-.79-.97-.72-2.49-.56-3.5Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,13.21c-.67,.97-1.76,1.29-2.44,.91-.42-.23-.76-.75-.7-1.31,.08-.71,.8-1.19,1.43-1.21,.79-.03,1.58,.64,1.71,1.61Z",
    style: {
      fill: "#bcc0c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.42,12.94c0,.52-.42,.94-.94,.94s-.94-.42-.94-.94,.42-.94,.94-.94,.94,.42,.94,.94Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,12.94c0,.16-.13,.28-.28,.28s-.28-.13-.28-.28,.13-.28,.28-.28,.28,.13,.28,.28Z",
    style: {
      fill: "#e3e0db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,14.92l-1.07,2.32c.06,.06,.47,.49,1.12,.46,.57-.03,.92-.38,.99-.46-.35-.77-.7-1.55-1.05-2.32Z",
    style: {
      fill: "#e3e0db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.28,13.21c.67,.97,1.76,1.29,2.44,.91,.42-.23,.76-.75,.7-1.31-.08-.71-.8-1.19-1.43-1.21-.79-.03-1.58,.64-1.71,1.61Z",
    style: {
      fill: "#bcc0c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.02,12.94c0,.52,.42,.94,.94,.94s.94-.42,.94-.94-.42-.94-.94-.94-.94,.42-.94,.94Z",
    style: {
      fill: "#2f4954"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.17,12.94c0,.16,.13,.28,.28,.28s.28-.13,.28-.28-.13-.28-.28-.28-.28,.13-.28,.28Z",
    style: {
      fill: "#e3e0db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,16.04c-.37-.51-.75-.83-1.33-1.17-.82-.48-1.32-.78-2.05-.78-.73,0-1.24,.3-2.06,.78-.58,.34-.95,.66-1.33,1.17-.34,.46-.39,1-.15,1.35,.25,.36,.72,.38,.97,.4,.76,.05,1.32-.39,1.51-.55,.16-.2,.32-.44,.48-.72,.33-.59,.49-1.14,.58-1.57,.07,.39,.22,.91,.51,1.46,.18,.33,.37,.61,.55,.83,.19,.16,.75,.6,1.5,.55,.25-.01,.72-.04,.97-.4,.24-.35,.18-.89-.15-1.35Z",
    style: {
      fill: "#edf2f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.97,14.15c-.1-.31-1.4-.31-1.5,0-.07,.2,.39,.53,.74,.75,.41-.25,.83-.56,.76-.75Z",
    style: {
      fill: "#f0978e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.99,9.2c.67-.43,.92-.37,1-.58,.23-.63-1.58-2.19-2.21-1.82-.34,.2-.28,.91-.22,1.65,.04,.48,.11,1.27,.45,1.36,.22,.06,.34-.21,.97-.61Z",
    style: {
      fill: "#f0978e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,9.5s.11,.1,.21,.1c.12,0,.22-.08,.27-.19s.05-.23,.05-.35c0-.47,.01-.93,.02-1.4,0-.36,.01-.72-.07-1.08-.02-.1-.16-.31-.35-.4-.76-.35-2.57,1.51-2.29,2.04,.07,.13,.19,.04,.6,.21,.55,.23,1.28,.8,1.55,1.06Z",
    style: {
      fill: "#f0978e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.62,20.31c-2.42-.11-4.16-1.55-4.5-1.84-1.35-1.16-1.95-2.51-2.21-3.19l.23,.03c.14,.31,1.73,3.71,5.42,4.39,3.01,.56,6.17-.92,7.86-3.73l.22,.13c-1.57,2.67-4.27,4.33-7.03,4.21Z",
    style: {
      fill: "#968175"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.52,35.79c-.63-.18-1.19-.4-1.69-.64,.05,.36,.16,.88,.42,1.45,.25,.53,.54,.92,.77,1.19,.86,.25,2.1,.51,3.59,.5,1.34-.01,2.46-.24,3.27-.47,.06-.11,.1-.22,.12-.32,.19-.79-.38-1.5-.51-1.65-1.34,.33-3.53,.65-5.98-.06Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.56,34.59c-.19-.21-.39-.47-.58-.78-.18-.28-.31-.54-.42-.78-.83,.06-1.94,.05-3.2-.2-.95-.19-1.75-.46-2.39-.73-.1,.41-.18,.89-.21,1.43-.01,.27-.01,.53,0,.76,1.24,.37,2.95,.69,4.96,.55,.67-.05,1.29-.14,1.85-.26Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,32.3c0-.1,.04-.29,.17-.48,.15-.23,.35-.34,.44-.38-.48-.33-1.07-.81-1.65-1.48-.68-.79-1.11-1.56-1.37-2.14-.33,.15-.81,.42-1.28,.87-.46,.44-.74,.89-.91,1.2,.61,.47,1.38,1,2.33,1.48,.83,.42,1.6,.72,2.27,.93Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,28.71c-.3-.83-.38-1.57-.39-2.09l-2.47,.41c.15,.64,.45,1.52,1.03,2.46,.42,.67,.87,1.19,1.26,1.56l1.88-.19c-.38-.42-.93-1.13-1.3-2.16Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,28.65c-.51-1.2-.66-2.28-.69-3.04-.33,.11-.69,.22-1.07,.33-.42,.12-.83,.21-1.21,.29-.02,.62,.04,1.99,.93,3.29,.32,.47,.68,.82,.99,1.08,.67-.09,1.33-.17,2-.26-.31-.44-.66-1-.95-1.69Z",
    style: {
      fill: "#a58e7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.3,26.02c-.17-.9-.21-1.71-.19-2.37-.3,.24-.65,.49-1.05,.74-.32,.2-.64,.37-.93,.5,.02,.41,.08,.85,.18,1.31,.36,1.71,1.14,3,1.78,3.83,.56-.1,1.13-.2,1.69-.3-.51-.8-1.15-2.06-1.47-3.7Z",
    style: {
      fill: "#a58e7f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.13,30.39c.14-.05,.28-.1,.42-.15,.87-.33,1.86-.77,2.91-1.37,1.13-.64,2.08-1.31,2.84-1.92l.31,.39c-.79,.63-1.76,1.32-2.93,1.98-1.2,.68-2.32,1.17-3.29,1.52-.09-.15-.18-.3-.27-.45Z",
    style: {
      fill: "#968175"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.99,29.72c-.7-.45-1.44-.98-2.2-1.58-1-.8-1.86-1.6-2.59-2.34l.15-.21c.68,.72,1.52,1.51,2.54,2.31,1.06,.83,2.08,1.47,2.98,1.96-.3-.05-.59-.09-.89-.14Z",
    style: {
      fill: "#968175"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingroom3);
export default __webpack_public_path__ + "static/media/livingroom-3.ab63104e1d2bc90a51c6295c59890639.svg";
export { ForwardRef as ReactComponent };